import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { EventService } from 'src/app/services/event.service';
import { AccountsService } from 'src/app/services/accounts.service';
import { SettingsService } from 'src/app/services/settings.service';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { PhotoComponent } from 'src/app/components/photo';
import { FormsModule } from '@angular/forms';
import { settingsFeature } from 'src/app/store/settings.era';
import { accountsFeature } from 'src/app/store/accounts.era';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'duplicate-event-dialog',
    template: `
<div class="joi-dialog">
  <div mat-dialog-title>
      <span>Duplicate Event</span>
  </div>
  <div mat-dialog-content>
      <div class="dialog_content">
          <div>
              <div class="para">
                  {{account_usage_message}}
              </div>
              <div *ngIf="can_create">
                  <div class="para">
                      Enter a name for this event:
                  </div>
                  <mat-form-field class="general">
                      <input matInput name="event_name" [(ngModel)]="event_name" placeholder="Event Name" >
                  </mat-form-field>
              </div>
              <div class="label">
                  Account
              </div>
              <div *ngIf="accounts.length == 1 || !is_admin_on_source" class="para flex">
                  <photo [data]="use_account"></photo>
                  <div class="name">{{use_account.title}}</div>
              </div>
              <div *ngIf="accounts.length > 1 && is_admin_on_source" class="para">
                  <div [matMenuTriggerFor]="useAccount" class="dropdown_label">
                      <photo [data]="use_account"></photo>
                      <div class="name">{{use_account.title}}</div>
                      <icon class="drop" matIcon="arrow_drop_down"></icon>
                  </div>
                  <mat-menu #useAccount="matMenu" xPosition="before">
                      <button *ngFor="let acc of accounts"
                          mat-menu-item (click)="useThisAccount(acc)"
                          [disabled]="acc.is_readonly || acc.is_invited">{{acc.title || acc.id}}</button>
                  </mat-menu>
              </div>
              <div class="will_start_trial_message" *ngIf="will_start_trial">Note: Creating an event will start your 30 day free trial.</div>
              <div class="date_selection" *ngIf="formatted_existing_date">
                <div>The event you are duplicating starts on:</div>
                <div class="date">{{ formatted_existing_date | date:'EEEE d MMMM y' }}</div>
                <div>What date do you want the new event to start on?</div>
                <div class="date_picker primary" [ngClass]="{no_date: !formatted_date}" (click)="picker.open()">
                    <mat-datepicker-toggle color="primary" [for]="picker"></mat-datepicker-toggle>
                    {{formatted_date ? (formatted_date | date:'EEEE d MMMM y') : 'Select date ...'}}
                </div>
                <mat-form-field class="general date_field">
                    <input hidden matInput id="date" name="date" #pickerInput [matDatepicker]="picker" [(ngModel)]="formatted_date">
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
          </div>
      </div>
  </div>
  <div mat-dialog-actions class="lg">
      <button mat-button (click)="dialogRef.close()">Cancel</button>
      <button mat-button color="primary" *ngIf="can_create" [disabled]="!event_name" (click)="duplicate()">Duplicate</button>
      <button mat-button color="primary" *ngIf="!can_create" (click)="goToSubscriptions()">Get more events</button>
  </div>
</div>

  `,
    styles: [`
.joi-dialog .para { margin-bottom: 15px; }
.joi-dialog .flex { display: flex; }
.joi-dialog .label { font-size:11px; font-weight:bold; color:#999; text-transform:uppercase; padding-bottom: 5px; }
.joi-dialog .name { line-height: 21px; flex-grow:1;}
.joi-dialog .dropdown_label, .drop { display: flex; cursor: pointer; }
.joi-dialog .will_start_trial_message { position: relative; top: 15px; color: #999; font-style: italic; }
.joi-dialog .date_selection { padding-top: 10px; }
.joi-dialog .date { font-weight: bold; padding: 5px 0 20px;}
.joi-dialog .date_picker { top:0; }
  `],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatDatepickerModule, MatMenuModule, IconComponent, PhotoComponent, FormsModule]
})
export class DuplicateEventDialogComponent {

  event_name;
  accounts;
  use_account;
  can_create = false;
  is_admin_on_source;
  will_start_trial = false;
  account_usage_message = '';
  formatted_existing_date;
  formatted_date;

  constructor( public dialogRef: MatDialogRef<DuplicateEventDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    public userService: UserService,
    public eventService: EventService,
    public accountService: AccountsService,
    public settings:SettingsService,
    public router:Router,
    public store: Store
  ) {

    this.store.pipe(select(settingsFeature.selectUser), take(1)).subscribe(user => {
      this.store.pipe(select(accountsFeature.selectAccountsState), take(1)).subscribe(accounts => {
        if(!user.default_account){
          if(accounts.ids && accounts.ids.length){
            this.useThisAccount(accounts.entities[accounts.ids[0]])
          }
        }else{
          this.useThisAccount(accounts.entities[user.default_account], true)
        }
        this.accounts = accounts.ids.map(id=>accounts.entities[id]);
        const is_admin = accounts.entities[this.data.event.accountId].admin.findIndex(id=>id===userService.uid) > -1;
        const is_exec = accounts.entities[this.data.event.accountId].executive.findIndex(id=>id===userService.uid) > -1;
        this.is_admin_on_source = is_admin || is_exec;
      })
    })
    this.event_name = 'Copy of ' + this.data.event.title; // place holder
    this.eventService.copyTitle(this.data.event.title).then(title=>{
      this.event_name = title;
    })
    // console.log('data ', this.data)

    if (this.data.event.dates.length > 0) {
      this.formatted_existing_date = this.data.event.dates[0];
    }
  }

  useThisAccount(account,from_init?) {
    // todo: make this account their default
    this.use_account = account;
    if (!account) return;
    // docket parse
    this.will_start_trial = false;
    const active_events = account.docket.tally || 0;
    const event_limit = account.docket.limit;
    this.account_usage_message = 'No events available.  ';
    const is_active = ['fresh', 'incomplete', 'custom', 'active', 'trial', 'beta'].indexOf(account.docket.status) > -1;
    this.can_create = false
    if (account.is_suspended) {
      this.account_usage_message += "This account is suspended.";
    } else if (!is_active) {
      this.account_usage_message += "This account is not active.";
    } else if (event_limit === null && is_active) {
      this.can_create = true;
      this.account_usage_message = '';
      if (account.docket.status === 'fresh') {
        this.will_start_trial = true;
      }
    } else if (event_limit <= active_events) {
      this.account_usage_message += "This account has used up the " + event_limit + " available event" + (event_limit === 1 ? '' : 's') + ".";
    } else {
      this.can_create = true;
      this.account_usage_message = 'This account has used '
        + active_events + ' of it\'s '
        + event_limit + ' active events';
    }
  }

  goToSubscriptions() {
    this.router.navigate(['/account/'+ this.use_account.id]);
    this.dialogRef.close();
  }

  duplicate() {
    // if !this.formatted_existing_date new_date === this.formatted_existing_date
    this.dialogRef.close({event_name: this.event_name, use_account_id: this.use_account.id, new_date:this.formatted_date});
  }
}
